/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * A payer returned by Bridge's payer search; `id` is the Bridge payer id we persist.
 */
export interface BridgePayerSearchResult {
  id: string;
  name: string;
  code: string;
  hint?: string | null;
  member_id: boolean;
}
